module.exports = __webpack_public_path__ + "static/tax-year-140f8960afe2a88668cf5c6935eda409.svg";